module.exports = __webpack_public_path__ + "static/oldlogo-white-2173217aede0dc7ce2b4ed47dec1f2f5.png";